export enum TrendTendencyEnum {
    Undefined = undefined,
    Down = -1,
    Neutral,
    Up
}